const setMousePosition = (mouseX, mouseY) => dispatch =>
  dispatch({
    type: "ON_MOUSE_MOVE",
    payload: { x: mouseX, y: mouseY }
  })

export default setMousePosition